export const uniqueAndSorted = (arr: string[]) => [...new Set(arr)].sort();
